module.exports = __webpack_public_path__ + "img/3.f02ab3f5.jpg";